// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"12d0704e","132":"12e7aa96"}[chunkId] + ".chunk.css";
};